import { connect } from "react-redux";

import ZubehoerPayload from "./ZubehoerPayload";

import { accessoryIndexFromLocation,
	statePartToAnalogInputs } from "../model/Zubehoer";

const adaptPath = (state, path) => {
	let i = accessoryIndexFromLocation(path);
	if (i > 0) {
		return(statePartToAnalogInputs(state.ablauf.compressors[i - 1]));
	}
	return [];
};

export default connect(state => ({
	analog_inputs: adaptPath(state, state.router.location.pathname),
	units: state.units
}))(ZubehoerPayload);
